import {useTenderCrud} from "../../../../shared/hooks/useTenderCrud";
import {CrudService} from "../../service";
import {CrudCreate} from "../../../../shared/crud/CrudCreate";
import {CrudTable} from "../../../../shared/crud/CrudTable";
import {Pagination} from "../../../../shared/paginations/Paginations";
import {CrudUpdate} from "../../../../shared/crud/CrudUpdate";

export const CommissionerList = () => {

    const {
        page,
        handlePages,
        totalPages,
        listOfAllData,
        updateData,
        createData,
        getCurrentDataID,
        changeHandler,
        showForm,
        setShowForm,
        filterData,
        selectedData
    } = useTenderCrud({
        getData: CrudService.getCommissioner,
        getMany: CrudService.getCommissioners,
        putData: CrudService.putCommissioner,
        addData: CrudService.addCommissioner
    });

    const tableHead = ['Name', 'Created at', 'Updated at', 'Actions']

    return (
        <div className="col-12">
            <div className="row">
                <div className="col-12">
                    <CrudCreate showForm={showForm} setShowForm={setShowForm} createData={createData} mainField="name"
                                title="Commissioner"
                                changeHandler={changeHandler}/>
                </div>
            </div>
            <div className="row">
                <CrudTable filterData={filterData} getCurrentDataID={getCurrentDataID} listOfAllData={listOfAllData}
                           isDeleteCrud={false}
                           mainField="name"
                           tableHead={tableHead}
                           title="Commissioner"/>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-end">
                {totalPages <= 1 ? '' :
                    <Pagination
                        page={page}
                        totalPages={totalPages}
                        handlePagination={handlePages}
                    />
                }
            </div>
            <CrudUpdate updateData={updateData} changeHandler={changeHandler} selectedData={selectedData!}
                        mainField="name" title="Commissioner"/>
        </div>
    )
}